import makeStyles from '@material-ui/core/styles/makeStyles';
import { ISpcTheme } from '../../../theme/ISpcTheme';

const GUTTER = 2;

export type ButtonWithIconClasses = 'root' | 'icon' | 'disabledIcon';

const buttonWithIconStyles = makeStyles<ISpcTheme, { iconSize: number; hideIcon: boolean }, ButtonWithIconClasses>(
  theme => ({
    root: {
      paddingTop: 0,
      paddingBottom: 0,
      paddingRight: props => (props.hideIcon ? 20 : props.iconSize + 10),
      position: 'relative',
      alignContent: 'center',
      display: 'flex',
      '&:hover span:last-child': {
        opacity: 0.96,
      },
    },
    icon: {
      display: props => (props.hideIcon ? 'none' : 'block'),
      position: 'absolute',
      top: GUTTER,
      right: GUTTER,
      height: props => props.iconSize - GUTTER * 2,
      width: props => props.iconSize - GUTTER * 2,
      background: theme.palette.primary.contrastText,
      borderRadius: '30px',
    },
    disabledIcon: {},
  }),
  { name: 'SPC_ButtonWithIcon' },
);

export default buttonWithIconStyles;
